import Fse from "../script/Fse";

export default {
    namespaced: true,

    state() {
        return {
            saisieFSE: null,
            saisieFseSelectedIndex: 0,
            facfse: null,
            formsoin: null,
            patientCourant: null,
            // AMC scannee (camera / drag-drop / lecteur serie) en attente d'application
            // dans l'ecran Complementaire. { numeroAMC, csr, numeroAdherent, typeConvention }.
            amcEnAttente: null,
            // Reflet de l'ouverture du dialog Complementaire (NewFSE) : permet a
            // App.vue de savoir s'il faut ouvrir l'ecran ou juste le remplir.
            dialogComplementaireOuvert: false,
            // Derniere lecture generique non-AMC (medicament / ePrescription / RPPS)
            // remontee du natif : plomberie en place, comportement metier a definir.
            lectureGeneriqueEnAttente: null,
        }
    },
    // Permet de récupérer les objets se trouvant dans state
    getters: {
        getSaisieFSE(state) {
            return state.saisieFSE;
        },
        getSaisieFseSelectedIndex(state) {
            return state.saisieFseSelectedIndex;
        },
        getFacfse(state) {
            return state.facfse;
        },
        getPatientCourant(state) {
            return state.patientCourant;
        },
        getAmcEnAttente(state) {
            return state.amcEnAttente;
        },
        isDialogComplementaireOuvert(state) {
            return state.dialogComplementaireOuvert;
        },
        getLectureGeneriqueEnAttente(state) {
            return state.lectureGeneriqueEnAttente;
        },
    }
    ,
    //Les mutations sont appellés pat les actios
    mutations: {
        setSaisieFSE(state, obj) {
            state.saisieFSE = obj;
        },
        setSaisieFseSelectedIndex(state, index) {
            state.saisieFseSelectedIndex = index;
        },
        setFacfse(state, newFacture) {
            state.facfse = newFacture;
        },
        setPatientCourant(state, patient) {
            state.patientCourant = patient;
        },
        setAmcEnAttente(state, infos) {
            state.amcEnAttente = infos;
        },
        setDialogComplementaireOuvert(state, ouvert) {
            state.dialogComplementaireOuvert = !!ouvert;
        },
        setLectureGeneriqueEnAttente(state, lecture) {
            state.lectureGeneriqueEnAttente = lecture;
        },
        //init facfse and saisie fse
        initParams(state ) {
            Fse.getFacfse()
                .then(response => {
                    console.log(state);
                    state.facfse = response
                    console.log(response)
                })
                .catch(error => { console.error(error) });

            Fse.getSaisieFSE()
                .then(response => {
                    state.saisieFSE = response
                    console.log(response)
                })
                .catch(error => { console.error(error) });
        },
    },

    actions: {
        setSaisieFSE({ commit }, obj) {
            commit("setSaisieFSE", obj);
        },
        setPatientCourant({ commit }, patient) {
            commit("setPatientCourant", patient);
        },
        setSaisieFseSelectedIndex({ commit }, index) {
            commit("setSaisieFseSelectedIndex", index);
        },
        initParams({ commit }) {
            commit('initParams');
        },
        async enregistrerFse() {
            try {
                // IMPORTANT : ne PAS envoyer de body. L'endpoint FSE/enregistrerFse attend un
                // Formsoin (pas un facfse) et, si le body est non nul, il ECRASE l'instance
                // serveur Formsoin.FormSoin_Instance avant enregreg_Click(). Le facfse a deja
                // ete pousse via setFacFSE juste avant (cf NewFSE.enregistrer) ; on appelle donc
                // sans argument pour que le backend enregistre son etat serveur courant.
                // Retour backend : bool (true = enregistrement OK).
                const response = await Fse.enregistrerFse();
                return response;
            } catch (error) {
                console.error("Erreur lors de l'enregistrement de la FSE :", error);
                throw error;
            }
        },

        async fetchFacfse({ commit }) {
            try {
                const response = await Fse.getFacfse();
                commit("setFacfse", response);
                return response;
            } catch (error) {
                console.error("Erreur lors du fetchFacfse :", error);
                throw error;
            }
        },

        async setFacfse({ commit }, newFacture) {
            try {
                const response = await Fse.setFacfse(newFacture);
                commit("setFacfse", newFacture);
                return response;
            } catch (error) {
                console.error("Erreur lors du setFacfse :", error);
                throw error;
            }
        },

        // AMC scannee cote natif. On la met "en attente" : l'ecran Complementaire
        // (GestionComplementaire, monte dans NewFSE) la consomme pour se remplir.
        // - Ecran deja ouvert -> il se remplit directement (watch amcEnAttente).
        // - Ecran ferme -> NewFSE ouvre le dialog pre-rempli (bascule TP compl.),
        //   l'utilisateur complete le routage (annuaire) et valide -> recalcul.
        // NB : pas de recalcul STS silencieux ici (routage B2 obligatoire absent
        //      du QR AMC ; cf. AnnuaireAMC.js). Voir STS.setComplementaire.
        traiterAmcScannee({ commit }, infos) {
            commit('setAmcEnAttente', infos || null);
        },
    }
}
